import { accidentInvestigationRecordTemplate } from "./template/accident-investigation-record";
import { accountDeleteTemplate } from "./template/account-delete";
import { businessTicketTemplate } from "./template/business-ticket";
import { businessVehicleTemplate } from "./template/business-vehicle";
import { businessVehicleCardLongTermEvictTemplate } from "./template/business-vehicle-card-long-term-evict";
import { businessVehicleCardLongTermProvideTemplate } from "./template/business-vehicle-card-long-term-provide";
import { businessVehicleCardLongTermRenewTemplate } from "./template/business-vehicle-card-long-term-renew";
import { businessVehicleCardProvideTemplate } from "./template/business-vehicle-card-provide";
import { businessVehicleCardRenewTemplate } from "./template/business-vehicle-card-renew";
import { changePersonTemplate } from "./template/change-person";
import { demandForSupplyTemplate } from "./template/demand-for-supply";
import { eprTemplate } from "./template/epr";
import { externalBusinessVehicleCardLongTermEvictTemplate } from "./template/external-business-vehicle-card-long-term-evict";
import { externalBusinessVehicleCardLongTermProvideTemplate } from "./template/external-business-vehicle-card-long-term-provide";
import { externalBusinessVehicleCardLongTermRenewTemplate } from "./template/external-business-vehicle-card-long-term-renew";
import { externalBusinessVehicleCardProvideTemplate } from "./template/external-business-vehicle-card-provide";
import { externalBusinessVehicleCardRenewTemplate } from "./template/external-business-vehicle-card-renew";
import { exportWarehouseTemplate } from "./template/export-warehouse-template";
import { listCodeTemplate } from "./template/list-code";
import { recallToolTemplate } from "./template/recall-tool";
import { repairToolTemplate } from "./template/repair-tool";
import { securityCardsToExternalEntitiesLongTermEvictTemplate } from "./template/security-cards-to-external-entities-long-term-evict";
import { securityCardsToExternalEntitiesLongTermProvideTemplate } from "./template/security-cards-to-external-entities-long-term-provide";
import { securityCardsToExternalEntitiesLongTermRenewTemplate } from "./template/security-cards-to-external-entities-long-term-renew";
import { securityCardsToExternalEntitiesProvideTemplate } from "./template/security-cards-to-external-entities-provide";
import { securityCardsToExternalEntitiesRenewTemplate } from "./template/security-cards-to-external-entities-renew";
import { securityControlLongTermEvictTemplate } from "./template/security-control-long-term-evict";
import { securityControlLongTermProvideTemplate } from "./template/security-control-long-term-provide";
import { securityControlLongTermRenewTemplate } from "./template/security-control-long-term-renew";
import { securityControlProvideTemplate } from "./template/security-control-provide";
import { securityControlRenewTemplate } from "./template/security-control-renew";
import type { GetTemplate, GetTemplateFields, Templates } from "./types";
import { monthlyTrainingPlanTemplate } from "./template/monthly-training-plan";
import { configEmployeeTemplate } from "./template/config-employees";
import { configSoftwareTemplate } from "./template/config-software";
import { changEprTemplate } from "./template/change-epr";

/**
 * Add more template here...
 */
const templates: Templates = {
  epr: eprTemplate,
  "change-epr": changEprTemplate,
  "list-cost": listCodeTemplate,
  "recall-tool": recallToolTemplate,
  "repair-tool": repairToolTemplate,
  "account-delete": accountDeleteTemplate,
  "demand-for-supply": demandForSupplyTemplate,
  "business-vehicle": businessVehicleTemplate,
  "business-ticket": businessTicketTemplate,
  "change-person": changePersonTemplate,
  "security-control-provide": securityControlProvideTemplate,
  "security-control-renew": securityControlRenewTemplate,
  "security-control-long-term-provide": securityControlLongTermProvideTemplate,
  "security-control-long-term-renew": securityControlLongTermRenewTemplate,
  "security-control-long-term-evict": securityControlLongTermEvictTemplate,
  "security-cards-to-external-entities-provide": securityCardsToExternalEntitiesProvideTemplate,
  "security-cards-to-external-entities-renew": securityCardsToExternalEntitiesRenewTemplate,
  "security-cards-to-external-entities-long-term-provide": securityCardsToExternalEntitiesLongTermProvideTemplate,
  "security-cards-to-external-entities-long-term-renew": securityCardsToExternalEntitiesLongTermRenewTemplate,
  "security-cards-to-external-entities-long-term-evict": securityCardsToExternalEntitiesLongTermEvictTemplate,
  "business-vehicle-card-provide": businessVehicleCardProvideTemplate,
  "business-vehicle-card-renew": businessVehicleCardRenewTemplate,
  "business-vehicle-card-long-term-provide": businessVehicleCardLongTermProvideTemplate,
  "business-vehicle-card-long-term-renew": businessVehicleCardLongTermRenewTemplate,
  "business-vehicle-card-long-term-evict": businessVehicleCardLongTermEvictTemplate,
  "external-business-vehicle-card-provide": externalBusinessVehicleCardProvideTemplate,
  "external-business-vehicle-card-renew": externalBusinessVehicleCardRenewTemplate,
  "external-business-vehicle-card-long-term-provide": externalBusinessVehicleCardLongTermProvideTemplate,
  "external-business-vehicle-card-long-term-renew": externalBusinessVehicleCardLongTermRenewTemplate,
  "external-business-vehicle-card-long-term-evict": externalBusinessVehicleCardLongTermEvictTemplate,
  "export-warehouse": exportWarehouseTemplate,
  "accident-investigation-record": accidentInvestigationRecordTemplate,
  "monthly-training-plan": monthlyTrainingPlanTemplate,
  "config-employee": configEmployeeTemplate,
  "config-software": configSoftwareTemplate,
};

export const getTemplate: GetTemplate = (templateType) => templates[templateType];

export const getTemplateFields: GetTemplateFields = (templateType) => templates[templateType].fields;

/**
 * Export all types
 */
export * from "./types";
